import React, { useContext, useEffect, useState } from 'react';
import { Store } from './Store';
import { BrowserRouter, Route, useHistory } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Container, Paper, Box, Button, Dialog } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';
import { useStyles } from './styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { Menu, MenuItem, Tabs, Tab } from '@mui/material'; // Ensure proper import from Material-UI
import { getUserData, getUserSettings, validateCustomerToken } from './actions';
import ChooseScreen from './screens/ChooseScreen';
import HomeScreen from './screens/HomeScreen';
import OrderScreen from './screens/OrderScreen';
import QueueScreen from './screens/QueueScreen';
import ReviewScreen from './screens/ReviewScreen';
import PaymentScreen from './screens/PaymentScreen';
import AdminScreen from './screens/AdminScreen';
import ProfileDetails from './screens/ProfileDetails';
import SelectBranch from './screens/SelectBranch';
import Cart from './screens/Cart';
import Favourites from './screens/Favourites';
import MyOrders from './screens/MyOrders';
import Rewards from './screens/Rewards';
import OurPrivacy from './screens/OurPolicy';
import InviteFriends from './screens/InviteFriend';

import SelectPaymentScreen from './screens/SelectPaymentScreen';
import CompleteOrderScreen from './screens/CompleteOrderScreen';
import SignUp from './screens/SignUp';
import SplashScreen from './SplashScreen'

import CircularProgress from '@mui/material/CircularProgress';
import CL_ChooseScreen from './clover/ChooseScreen';
import CL_HomeScreen from './clover/HomeScreen';
import CL_OrderScreen from './clover/OrderScreen';
import CL_QueueScreen from './clover/QueueScreen';
import CL_ReviewScreen from './clover/ReviewScreen';
import CL_PaymentScreen from './clover/PaymentScreen';
import CL_AdminScreen from './clover/AdminScreen';
import CL_SelectPaymentScreen from './clover/SelectPaymentScreen';
import CL_CompleteOrderScreen from './clover/CompleteOrderScreen';
//import CL_SignUp from './clover/SignUp';
import CL_ProfileDetails from './clover/ProfileDetails';
import CL_Cart from './clover/Cart';
import CL_Favourites from './clover/Favourites';
import CL_MyOrders from './clover/MyOrders';
import CL_Rewards from './clover/Rewards';
import CL_OurPrivacy from './clover/OurPolicy';
import CL_InviteFriends from './clover/InviteFriend';
import PWAInstallPrompt from './components/PWAInstallPrompt';

import './App.css';
import config, { getParameterByName, merchantCode } from './util';
// import { useNavigate } from 'react-router-dom';

let themes = [
  {
    typography: {
      h1: { fontWeight: 'bold' },
      h2: { fontSize: '2rem', color: 'black' },
      h3: { fontSize: '1.8rem', fontWeight: 'bold', color: 'black' },
    },
    palette: {
      primary: { main: '#F3CC43' },
      secondary: { main: '#118e16', contrastText: '#ffffff' },
    },
  },
  {
    typography: {
      h1: { fontWeight: 'bold' },
      h2: { fontSize: '2rem', color: 'black' },
      h3: { fontSize: '1.8rem', fontWeight: 'bold', color: 'black' },
    },
    palette: {
      primary: { main: '#672b2b' },
      secondary: { main: '#118e16', contrastText: '#f4afaf' },
    },
  },
];

let themeInx = getParameterByName('theme') || sessionStorage.getItem('theme');
sessionStorage.setItem('theme', themeInx);
themeInx = themeInx && themeInx.length ? parseInt(themeInx) : 0;
const theme = createTheme(themes[themeInx]);

function App({ log }) {
  const { state, dispatch } = useContext(Store);
  const history = useHistory(); // Add this hook
  const styles = useStyles();
  const [signDialog, setSignDialog] = useState(false);
  const [guest, setGuest] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabSel, setTabSel] = React.useState(0);
  const [splashRunning, setSplashRunning] = useState(!localStorage.getItem("splashShown") ? true : false);
  let { setting } = state.userData;
  console.log(setting);
  const handleTabChange = (event, newValue) => {
    setTabSel(newValue);
  }
  const handleClose = () => {
    setMenuOpen(false);
  };
  let { signInInfo } = state.signInData;

  useEffect(() => {
    if (getParameterByName('token')) {
      console.log('--checking token---');
      validateCustomerToken(dispatch, getParameterByName('token'), getParameterByName('merchantCode'));

      setTimeout(() => {
        const url = new URL(window.location);
        const params = new URLSearchParams(url.search);
        params.delete("token");
        console.log(params);
        console.log(window.location.href);
        window.location.href = window.location.origin + '?' + params;
      }, 1500)
    }
  }, [])
  useEffect(async () => {
    const isHomePage = window.location.pathname === '/';

    await getUserData(dispatch);

  }, [dispatch]);



  const handleDialog = () => {
    setSignDialog(false);
    setGuest(true);
  };

  const handleLogout = () => {
    sessionStorage.clear("customerInfo");
    localStorage.removeItem('userInfo');
    setSignDialog(true);
  };
  const goto = (subpath) => {
    history.push('/' + subpath + '?' + window.location.href.split('?')[1]);
  }
  const goToProfileHandler = () => {
    const loginData = sessionStorage.getItem('customerInfo')
      ? JSON.parse(sessionStorage.getItem('customerInfo'))
      : null;
    if (loginData !== null) {
      setAnchorEl(null); // close the menu if open
      history.push('/profile?' + window.location.href.split('?')[1]);
      window.location.reload();
      //window.location.href = `/profile`; // force reload
    } else {
      setAnchorEl(null);
      setSignDialog(true); // prompt sign up if not logged in
    }
  };

  let customerInfo = sessionStorage.getItem("customerInfo")
    ? JSON.parse(sessionStorage.getItem("customerInfo"))
    : null;

  let runningOrder = localStorage.getItem('runningOrder');

  if ((setting && !setting.length) && localStorage.getItem('userInfo')) {
    setting = JSON.parse(localStorage.getItem('userInfo'));
  }



  let renderRoutes = () => {
    return <>{setting && !setting.activeProviderId && (
      <div>
        <Route path="/home" component={HomeScreen} exact />
        <Route path="/admin" component={AdminScreen} exact />
        <Route path="/queue" component={QueueScreen} exact />
        <Route path="/choose" component={ChooseScreen} exact />
        <Route path="/order" component={OrderScreen} exact />
        <Route path="/" component={OrderScreen} exact />
        <Route path="/review" component={ReviewScreen} exact />
        <Route
          path="/collection-mode"
          component={SelectPaymentScreen}
          exact
        />
        <Route path="/cart" component={Cart} exact />
        <Route path="/favourites" component={Favourites} exact />
        <Route path="/payment" component={PaymentScreen} exact />
        <Route
          path="/complete"
          component={CompleteOrderScreen}
          exact
        />
        <Route path="/signup" component={SignUp} exact />
        <Route path="/choose-branch" component={SelectBranch} exact />
        <Route path="/myorders" component={MyOrders} exact />
        <Route path="/rewards" component={Rewards} exact />
        <Route path="/policy" component={OurPrivacy} exact />
        <Route path="/invitefriend" component={InviteFriends} exact />
        <Route path="/profile" component={ProfileDetails} exact />
      </div>
    )}
      {setting &&
        setting.posProviderName &&
        setting.posProviderName.toUpperCase() === 'CLOVER' && (
          <div>
            <Route path="/home" component={CL_HomeScreen} exact />
            <Route path="/admin" component={CL_AdminScreen} exact />
            <Route path="/queue" component={CL_QueueScreen} exact />
            <Route path="/choose" component={CL_ChooseScreen} exact />
            <Route path="/order" component={CL_OrderScreen} exact />
            <Route path="/" component={SignUp} exact />
            <Route path="/review" component={CL_ReviewScreen} exact />
            <Route path="/cart" component={CL_Cart} exact />
            <Route path="/favourites" component={CL_Favourites} exact />
            <Route
              path="/collection-mode"
              component={CL_SelectPaymentScreen}
              exact
            />
            <Route path="/payment" component={CL_PaymentScreen} exact />
            <Route
              path="/complete"
              component={CL_CompleteOrderScreen}
              exact
            />
            <Route path="/signup" component={SignUp} exact />
            <Route path="/profile" component={CL_ProfileDetails} exact />
            <Route path="/myorders" component={CL_MyOrders} exact />
            <Route path="/rewards" component={CL_Rewards} exact />
            <Route path="/policy" component={CL_OurPrivacy} exact />
            <Route path="/invitefriend" component={CL_InviteFriends} exact />
          </div>
        )} </>;

  }

  return (
    <BrowserRouter>
      <>
        <Helmet>
          <title>Online Order</title>
        </Helmet>
        {!setting ? <CircularProgress color="secondary" /> : <div>{!localStorage.getItem('isLoginSkipped') && <Dialog
          aria-labelledby="max-width-dialog-title"
          open={signDialog}
          fullWidth={true}
          maxWidth={state.widthScreen ? 'sm' : 'xs'}
        >
          <div >
            {setting && setting.posProviderName && setting.posProviderName.toUpperCase() === 'CLOVER' &&
              <SignUp handleDialog={handleDialog} setOpenSign={setSignDialog} />
            }
            {setting && !setting.activeProviderId && <SignUp handleDialog={handleDialog} setOpenSign={setSignDialog} />}
          </div>
        </Dialog>}
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <PWAInstallPrompt />
            <Container maxWidth={state.widthScreen ? 'xl' : 'sm'}>
              {splashRunning && <SplashScreen onFinish={setSplashRunning} />}
              <Paper style={{ overflow: "hidden" }}>
                <span>
                  {false && !splashRunning && customerInfo && (
                    <AccountCircleIcon className="menu_icon" id="menu-button" onClick={(event) => setAnchorEl(event.currentTarget)} style={{ zIndex: 9999, marginTop: "10px", cursor: 'pointer' }} />
                  )}


                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)} // Close menu on click outside
                    style={{ zIndex: 1300 }} // Ensure high enough z-index for visibility
                  >
                    <MenuItem onClick={() => console.log('Navigate to Past Orders')}>
                      All Orders
                    </MenuItem>
                    <MenuItem onClick={goToProfileHandler}>
                      Your Profile
                    </MenuItem>
                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                  </Menu>
                </span>

                {!splashRunning && renderRoutes()}

              </Paper>


            </Container>
          </ThemeProvider></div>}
      </>
    </BrowserRouter>
  );
}

export default App;
